
// Debounce which returns a promise
export function debounce<T extends unknown[], U>(
  callback: (...args: T) => PromiseLike<U> | U,
  delay: number
): (...args: T) => Promise<U> {
  let timeoutId: NodeJS.Timer;

  return (...args: T): Promise<U> => {
    clearTimeout(timeoutId);
    return new Promise((resolve) => {
      timeoutId = setTimeout(() => resolve(callback(...args)), delay);
    });
  };
}

export function getPathWithSlash() {
    const path = window.location.pathname;

    return path[path.length - 1] === "/"
        ? path
        : path + "/";
}